import { render, staticRenderFns } from "./FreQuestions.vue?vue&type=template&id=fa9bcf3a&scoped=true&"
import script from "./FreQuestions.vue?vue&type=script&lang=js&"
export * from "./FreQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FreQuestions.vue?vue&type=style&index=0&id=fa9bcf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9bcf3a",
  null
  
)

export default component.exports